import { PageTypeEnum } from '@moonpig/web-shared-products'
import { useSearchStore } from '../SearchStore'
import { SearchFiltersFacet } from '../../pages/GalleryPage/types'

export const usePageContextFacets = (): SearchFiltersFacet[] => {
  const pageContext = useSearchStore(store => store.pageContext)
  const selectedFilters = useSearchStore(store => store.selectedFilters)
  const preAppliedFilters = useSearchStore(store => store.preAppliedFilters)
  const isCollection = pageContext.type === PageTypeEnum.COLLECTION

  const [collectionGroup, collectionFacetKey] =
    pageContext.collection?.split(':') || []

  return [
    ...selectedFilters.map(f => ({ facetKey: f.id, group: f.parent })),
    ...preAppliedFilters.map(f => ({
      facetKey: f.key,
      group: f.group,
    })),
    ...(isCollection
      ? [{ group: collectionGroup, facetKey: collectionFacetKey }]
      : []),
  ]
}
